<div *ngIf="localService.languageContent && localService.languageContent.pwd_container" class="row">
  <div class="modal-body modal-body-no-flexible-height">
    <div style="text-align: justify; line-height: 25px; color: darkslategray;">
      {{localService.languageContent.pwd_container.new_password_title}}
    </div>
    <div style="text-align:center">
      <input autocomplete="off" style="max-width:300px;" type="password" [ngClass]="txtNewPwd == '' ? '' : 'ta'" id="{{elementIds.pwd}}" [(ngModel)]="txtNewPwd" placeholder="{{localService.languageContent.pwd_container.new_password}}" title="{{localService.languageContent.pwd_container.new_password}}" (keydown.enter)="localService.onFocusNextInput(elementIds.pwd_confirm,1)" />
    </div>
    <div style="text-align:center">
      <input autocomplete="off" style="max-width:300px;" type="password" [ngClass]="txtNewPwdConfirmed == '' ? '' : 'ta'" id="{{elementIds.pwd_confirm}}" [(ngModel)]="txtNewPwdConfirmed" placeholder="{{localService.languageContent.pwd_container.new_password_confirm}}" title="{{localService.languageContent.pwd_container.new_password_confirm}}" (keydown.enter)="onSave()" />
    </div>
    <div *ngIf="message != ''">
      <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'yellowgreen' }">{{message}}</span>
    </div>
  </div>
  <div class="modal-footer">
    <button id="{{elementIds.save}}" type="button" class="btn btn-primary" (click)="onSave()">{{localService.languageContent.common.continue}}</button>
  </div>
</div>
